import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type {
  RawVerifyPasswordRequest,
  RawVerifyPasswordResponse,
  RawUpdatePasswordRequest,
  RawUpdatePasswordResponse,
  RawVerifyMobileRequest,
  RawVerifyMobileResponse,
  RawUpdateMobileRequest,
  RawReadUserProfileResponse,
  RawUpdateUserProfileRequest,
  RawUpdateUserProfileResponse,
  RawProfileConsentResponse,
  RawUpdateProfileConsentRequest,
  RawUpdateProfileConsentResponse,
  RawAlarmRequest,
  RawAlarmResponse,
} from '../types/user';
import type { RequestOptions } from '../types/common';

export function createUserApi(http: Http) {
  return {
    async verifyPassword(data: RawVerifyPasswordRequest): Promise<RawVerifyPasswordResponse> {
      const res = await http.post<RawVerifyPasswordResponse>(endpoints.user.passwordVerify, data);
      return res.data;
    },

    async updatePassword(data: RawUpdatePasswordRequest): Promise<RawUpdatePasswordResponse> {
      const res = await http.put<RawUpdatePasswordResponse>(endpoints.user.password, data);
      return res.data;
    },

    async verifyMobile(
      data: RawVerifyMobileRequest,
      verifyToken?: string,
    ): Promise<RawVerifyMobileResponse> {
      const res = await http.post<RawVerifyMobileResponse>(
        endpoints.user.mobileVerify,
        data,
        verifyToken !== undefined ? { params: { token: verifyToken } } : undefined,
      );
      return res.data;
    },

    async updateMobile(
      code: string,
      data: RawUpdateMobileRequest,
    ): Promise<RawVerifyMobileResponse> {
      const res = await http.put<RawVerifyMobileResponse>(endpoints.user.mobile, data, {
        params: { code },
      });
      return res.data;
    },

    async getProfile(options?: RequestOptions): Promise<RawReadUserProfileResponse> {
      const res = await http.get<RawReadUserProfileResponse>(endpoints.user.profile, {
        signal: options?.signal,
      });
      return res.data;
    },

    async updateProfile(data: RawUpdateUserProfileRequest): Promise<RawUpdateUserProfileResponse> {
      const res = await http.put<RawUpdateUserProfileResponse>(endpoints.user.profile, data);
      return res.data;
    },

    async getConsents(options?: RequestOptions): Promise<RawProfileConsentResponse> {
      const res = await http.get<RawProfileConsentResponse>(endpoints.user.consents, {
        signal: options?.signal,
      });
      return res.data;
    },

    async updateConsents(
      data: RawUpdateProfileConsentRequest,
    ): Promise<RawUpdateProfileConsentResponse> {
      const res = await http.put<RawUpdateProfileConsentResponse>(endpoints.user.consents, data);
      return res.data;
    },

    async getAlarm(options?: RequestOptions): Promise<RawAlarmResponse> {
      const res = await http.get<RawAlarmResponse>(endpoints.user.alarm, {
        signal: options?.signal,
      });
      return res.data;
    },

    async updateAlarm(data: RawAlarmRequest): Promise<RawAlarmResponse> {
      const res = await http.put<RawAlarmResponse>(endpoints.user.alarm, data);
      return res.data;
    },
  };
}
